import { Component, OnInit, OnDestroy, OnChanges, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

// Interfaces
import { IComponent } from '../../interfaces';

// services
import * as srv from '../../services';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements IComponent, OnInit, OnDestroy {
  // Implement IComponent
  name = 'LoaderComponent';
  subscriptions: Subscription[] = [];

  // Implement local variable
  @Input() LOAD: boolean;
  @Input() NAME: string;

  constructor(
    public loader: srv.LoaderService
  ) { }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
    delete this.subscriptions;
  }
}

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoadingComponent implements IComponent, OnInit, OnDestroy, OnChanges {
  // Implement IComponent
  name = 'LoadingComponent';
  subscriptions: Subscription[] = [];

  // Implement local variable
  @Input() LOAD: boolean;
  @Input() NAME: string;
  @Input() IMAGE: string;
  constructor(
    public loader: srv.LoaderService
  ) { }

  ngOnInit() {

  }

  ngOnChanges() {
    'Changing inputs'.logWithObject(this.name, [this.IMAGE]);
    if (this.IMAGE !== undefined) {
      this.IMAGE = this.IMAGE + ' ' + 'loading';
    } else {
      this.IMAGE = 'loading';
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
    delete this.subscriptions;
  }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/loader/loader.component.ts